module.exports = __webpack_public_path__ + "img/addr-book.90b0548d.svg";